import { SearchTerm } from "./SearchTerm";

const PermissionSearch: SearchTerm[] = [
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    }
];

export default PermissionSearch;
